module.exports = __webpack_public_path__ + "media/newstyle/images/quadrado-white-e1b3dd0c23999694d1099523ebd34b64.svg";